var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("el-row", { staticClass: "filter" }, [
        _c(
          "div",
          {
            staticStyle: {
              width: "80%",
              margin: "0 auto",
              "margin-top": "20px",
              "margin-bottom": "20px"
            }
          },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "demo-ruleForm",
                attrs: {
                  model: _vm.form,
                  rules: _vm.rules,
                  "label-width": "120px"
                }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "代采组id", prop: "pgname" } },
                  [
                    _c("el-input", {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.pgid,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "pgid", $$v)
                        },
                        expression: "form.pgid"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "代采组", prop: "pgname" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.pgname,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "pgname", $$v)
                        },
                        expression: "form.pgname"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "代采组昵称", prop: "pgnick" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.pgnick,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "pgnick", $$v)
                        },
                        expression: "form.pgnick"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "代采组报单名", prop: "pgbilling" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.pgbilling,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "pgbilling", $$v)
                        },
                        expression: "form.pgbilling"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "城市：" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "城市" },
                        on: { change: _vm.onCityChange },
                        model: {
                          value: _vm.form.city,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "city", $$v)
                          },
                          expression: "form.city"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: { value: "0", label: "全部" }
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.citys, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        })
                      ],
                      2
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "市场：" } },
                  [
                    _c(
                      "el-card",
                      {
                        staticClass: "box-card",
                        staticStyle: { "max-width": "1000px" },
                        attrs: { shadow: "never" }
                      },
                      [
                        _c(
                          "el-tabs",
                          {
                            attrs: { type: "card" },
                            on: { "tab-click": _vm.onMainMarketChange },
                            model: {
                              value: _vm.activeTab,
                              callback: function($$v) {
                                _vm.activeTab = $$v
                              },
                              expression: "activeTab"
                            }
                          },
                          _vm._l(_vm.marketList, function(item) {
                            return _c(
                              "el-tab-pane",
                              {
                                key: item.key,
                                attrs: { label: item.label, name: item.key }
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(item.label) +
                                        "\n                  "
                                    ),
                                    _vm.form.market_sub_id["" + item.key] &&
                                    _vm.form.market_sub_id["" + item.key]
                                      .length > 0
                                      ? _c(
                                          "span",
                                          { staticStyle: { color: "#fc1" } },
                                          [
                                            _vm._v(
                                              "\n                    （已选" +
                                                _vm._s(
                                                  _vm.form.market_sub_id[
                                                    "" + item.key
                                                  ].length
                                                ) +
                                                "个）\n                  "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-checkbox-group",
                          {
                            model: {
                              value: _vm.form.market_sub_id[_vm.activeTab],
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form.market_sub_id,
                                  _vm.activeTab,
                                  $$v
                                )
                              },
                              expression: "form.market_sub_id[activeTab]"
                            }
                          },
                          _vm._l(_vm.subMarketList, function(v) {
                            return _c(
                              "el-checkbox",
                              { key: v.key, attrs: { label: v.key } },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(v.label) +
                                    "\n              "
                                )
                              ]
                            )
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否启用", prop: "is_use" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "是否启用" },
                        model: {
                          value: _vm.form.is_use,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_use", $$v)
                          },
                          expression: "form.is_use"
                        }
                      },
                      _vm._l(_vm.is_use, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onSubmit }
                      },
                      [_vm._v("提交")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("el-row")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c_page-title" }, [
      _c("div", [_vm._v("编辑代采组")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f54a78d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f54a78d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/purchasegroup/UpdatePGroup.vue
// module id = null
// module chunks = 